import { BlockImageUploadEntityHydrated } from "@jackfruit/common"
import React from "react"
import { useSettings } from "~/hooks/useSettings"
import ImageUploadBlock from "./ImageUploadBlock"
import ImageUploadBlockV2 from "./ImageUploadBlockV2"

interface Props {
  config: BlockImageUploadEntityHydrated
}

const ImageUploadBlockWrapper: React.FC<Props> = ({ config }) => {
  const {
    settings: { isVNZCloudEnabled },
  } = useSettings()

  if (isVNZCloudEnabled) {
    return <ImageUploadBlockV2 config={config} />
  } else {
    return <ImageUploadBlock config={config} />
  }
}

export default ImageUploadBlockWrapper
